import React from 'react';

import type { PortalViewId } from './portalViewIds';
import { shouldDisplay } from './shouldDisplay';
import type { DisplayContext } from './types';
import { usePortalUser } from './usePortalUser';

type HideDisplayGuardProps = DisplayContext & {
  viewId?: PortalViewId;
  children: React.ReactNode;
};

const HideDisplayGuard = ({
  viewId,
  legacyVisibilityPermissions,
  exemptFromViewConfiguration,
  children,
}: HideDisplayGuardProps) => {
  const portalUser = usePortalUser();

  if (
    !shouldDisplay(portalUser, viewId, {
      legacyVisibilityPermissions,
      exemptFromViewConfiguration,
    })
  ) {
    return null;
  }

  return <>{children}</>;
};

export default HideDisplayGuard;
